import "./style.css";

export default function Pilares({ pilares, editMode, onError, onChange }) {
  const titulo = pilares?.title ?? "Nossos Pilares";
  const intro = pilares?.intro ?? "";
  const sourceItems = editMode
    ? Array.isArray(pilares?.items)
      ? pilares.items
      : []
    : Array.isArray(pilares?.items)
      ? pilares.items
      : [];
  const items = sourceItems.map(
    (item) =>
      typeof item === "string"
        ? { title: "", text: item }
        : { title: "", text: "", ...item },
  );

  const handleItemChange = (index, field, value) => {
    const updatedItems = items.map((item, itemIndex) =>
      itemIndex === index ? { ...item, [field]: value } : item,
    );
    onChange("items", updatedItems);
  };

  const handleAddItem = () => {
    onChange("items", [...items, { title: "", text: "" }]);
  };

  const handleRemoveItem = (index) => {
    onChange(
      "items",
      items.filter((_, itemIndex) => itemIndex !== index),
    );
  };

  if (editMode) {
    return (
      <section className="pilares">
        <input
          className="quem-somos-page-h2__input"
          value={titulo || ""}
          onChange={(e) => onChange("title", e.target.value)}
        />
        <textarea style={{height: "120px"}}
          className="quem-somos-page-p__textarea"
          value={intro || ""}
          onChange={(e) => onChange("intro", e.target.value)}
        />

        {items.map((item, i) => (
          <div key={i} className="pilares__item">
            <input
              className="pilares__item-title-input"
              value={item.title || ""}
              onChange={(e) => handleItemChange(i, "title", e.target.value)}
            />
            <textarea style={{height: "120px"}}
              className="quem-somos-page-p__textarea"
              value={item.text || ""}
              onChange={(e) => handleItemChange(i, "text", e.target.value)}
            />
            <button
              type="button"
              className="pilares__remover"
              onClick={() => handleRemoveItem(i)}
            >
              Remover pilar
            </button>
          </div>
        ))}

        <button
          type="button"
          className="pilares__adicionar"
          onClick={handleAddItem}
        >
          + Adicionar pilar
        </button>
      </section>
    )
  }

  return (
    <section className="pilares">
      <h2 className="pilares__titulo">{titulo}</h2>
      <p className="pilares__intro">{intro}</p>

      {items.map((item, i) => (
        <div key={i} className="pilares__item">
          <h3>{item.title}</h3>
          <p>{item.text}</p>
        </div>
      ))}
    </section>
  );
}
